// Анулиране на складов документ с причина (разнасяне, доставка, изписване…).
// Причината е незадължителна, но стои в документа, в справката и в „Анулирани
// дейности". Вариантът „корекция" анулира и отваря документа наново.
// Общият потвърждаващ диалог (components/confirm): заглавие-въпрос с номера,
// какво става с наличността, по желание преглед на количествата и бележка
// откъде се връща; фокусът е в полето за причина, Ctrl/Cmd+Enter потвърждава и
// от него, Esc отказва.
import { useState } from "react";
import { StopOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useInventoryShell } from "./shell/InventoryShellContext";
import { ConfirmDialog } from "./confirm/ConfirmDialog";
import type { ConfirmNote, ConfirmPreview } from "./confirm/confirmTypes";

type Props = {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  saving: boolean;
  onCancel: () => void;
  onConfirm: (reason: string | null) => void;
  // незадължителни: какво се връща/излиза от склада и дали може да се върне
  preview?: ConfirmPreview;
  note?: ConfirmNote;
};

export const AnnulDocumentModal = ({
  open,
  title,
  text,
  confirmLabel,
  saving,
  onCancel,
  onConfirm,
  preview,
  note,
}: Props) => {
  const { t } = useTranslation();
  const { isNarrow } = useInventoryShell();
  const [reason, setReason] = useState("");
  return (
    <ConfirmDialog
      open={open}
      afterClose={() => setReason("")}
      intent="danger"
      icon={<StopOutlined />}
      title={title}
      explanation={text}
      preview={preview}
      note={note}
      confirmLabel={confirmLabel}
      busy={saving}
      initialFocus="field"
      onConfirm={() => onConfirm(reason.trim() || null)}
      onCancel={onCancel}
    >
      <label className="flex flex-col gap-1.5 text-[13px] text-ink-2">
        {t("inventoryPage.annulReason")}
        <textarea
          rows={3}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder={t("inventoryPage.annulReasonPh")}
          className={`resize-y rounded-[9px] border border-shade-3 bg-surface px-3 py-2.5 text-ink outline-none focus:border-brand ${
            isNarrow ? "text-base" : "text-sm"
          }`}
        />
      </label>
    </ConfirmDialog>
  );
};

export default AnnulDocumentModal;
